<div *ngIf="address" (click)="loadGoogleMap()" class="address" [class.link]="linkToMap">
    <div class="line1">{{ address.line1 }}</div>
    <div class="line2" *ngIf="address.line2">{{ address.line2 }}</div>
    <div class="city-state-zip">{{ address.city }}, {{ address.state }} {{ address.zip }}</div>
</div>
